"use client";

import { Components } from "@/app/(components)/_components/Components";
import ActionMenu from "@/app/(components)/generics/ActionMenu/ActionMenu";
import IconDownload from "@/app/(components)/generics/Icons/IconDownload";
import IconRestart from "@/app/(components)/generics/Icons/IconRestart";
import IconSparkles from "@/app/(components)/generics/Icons/IconSparkles";
import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UserClientAvatar } from "@/app/types/client-avatar/UserClientAvatar";
import { PageParams } from "@/app/types/common/DefaultProps";

type Props = {
  params: PageParams;
  avatar: UserClientAvatar;
  onExtract?: (isEnrich: boolean, rebuild?: boolean) => void;
  triggerClassName?: string;
};

export default function AvatarCardMenu(props: Props) {
  const T = useT();
  const { params, avatar, onExtract, triggerClassName } = props;

  const canRunPaidActions = useCanRunPaidActions();

  const isExtracted = avatar.id !== -1;

  const handleExport = () => {
    ModalStore.getState().openModal(
      Components.ExportAvatar,
      T(TKey.CLIENT_AVATAR_EXPORT_ONE_TITLE) as string,
      { params, offerId: avatar.offerId },
    );
  };

  return (
    <ActionMenu
      triggerClassName={triggerClassName}
      items={[
        onExtract &&
          canRunPaidActions && {
            icon: <IconSparkles size={15} />,
            label: T(
              isExtracted ? TKey.CLIENT_AVATAR_ENRICH_BUTTON : TKey.CLIENT_AVATAR_EXTRACT_BUTTON,
            ) as string,
            onClick: () => onExtract(isExtracted),
          },
        onExtract &&
          canRunPaidActions &&
          isExtracted && {
            icon: <IconRestart size={15} />,
            label: T(TKey.CLIENT_AVATAR_REEXTRACT_BUTTON) as string,
            onClick: () => onExtract(false, true),
          },
        isExtracted && {
          icon: <IconDownload size={15} />,
          label: T(TKey.CLIENT_AVATAR_EXPORT_BUTTON) as string,
          onClick: handleExport,
        },
      ]}
    />
  );
}
